import { useMemo, type ReactNode } from "react";
import { MenuNavigationContextProvider } from "@repo/ui";
import {
  collectExamIdsFromEnrolledProgram,
  getGradeIdFromEnrolledProgram,
  getVerticalIdFromEnrolledProgram,
} from "@repo/utils";
import { useMyPrograms } from "../store/useAuthStore";

/**
 * Supplies `useMenuNavigationProgram()` from the default (or first) enrolled program.
 * Wrap the app inside this provider (see `App.tsx`).
 */
export function MenuNavigationProvider({ children }: { children: ReactNode }) {
  const enrolledPrograms = useMyPrograms();
  const { gradeId, examIds, verticalId } = useMemo(() => {
    const program =
      enrolledPrograms?.find((p) => p.isDefault) ?? enrolledPrograms?.[0];
    return {
      gradeId: getGradeIdFromEnrolledProgram(program ?? undefined),
      examIds: collectExamIdsFromEnrolledProgram(program ?? undefined),
      verticalId: getVerticalIdFromEnrolledProgram(program ?? undefined),
    };
  }, [enrolledPrograms]);

  return (
    <MenuNavigationContextProvider
      gradeId={gradeId}
      examIds={examIds}
      verticalId={verticalId}
    >
      {children}
    </MenuNavigationContextProvider>
  );
}
